import React, { useEffect, useState } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import Wrapper from "../Common/FilterWrapper/index";

import { Grid } from "../../components/Grid.components";
import { Boxed } from "../../components/Boxed.components";
import { Input } from "../../components/Input.components";
import { Text } from "../../components/Text.components";
import { Avatar } from "../../components/Avatar.components";
import { Button } from "../../components/Button.components";
import { Loader } from "../../components/Loader.components";
import { EmptyState } from "../../components/EmptyState.components";
import {
  TableComponent,
  PaginationComponent,
} from "../../components/Table.components";
import {
  PageTitle,
  Icon,
  StyledDrpDown,
  DropDownMenu,
} from "../../components/style";

import { calcViewMode, formatDate, formatDateTime } from "../../utils/utils";
import { USER_TYPE, pageOptions } from "../../utils/constant";
import { Theme } from "../../utils/theme";

import CreateModal from "./CreateModal/index";
import DeleteModal from "./DeleteModal/index";
import ResetModal from "./ResetModal/index";
import ViewUser  from  './ViewUser/index';

export const UserManagement = (props) => {
  // state props
  const {
    isLoading,
    usersList,
    usersTotal,
    fetchActionURL,
    accessList,
    profile,
    createUserModal,
    deleteUserModal,
    viewUserModal,
    resetModal,
  } = props;

  // dispatch props
  const {
    getAllUsers,
    openCreateModal,
    redirect,
    openDeleteModal,
    openResetModal,
    openViewModal,
    getSingleUser,
  } = props;

  useEffect(() => {
    let data = {
      page: 1,
      limit: 10,
    };
    getAllUsers(data);
  }, []);

  let viewMode = calcViewMode();

  const [desc, setDesc] = useState("");

  const handleDropDown = (item, record) => {
    // console.log(record);
    getSingleUser(record);
    switch (item.key) {
      case 1:
      redirect('/users/profile')
        break;
      case 2:
        setDesc(item.label);
        openResetModal();
        break;
      case 3:
        setDesc(item.label);
        openResetModal();
        break;
      case 4:
        openDeleteModal();
        break;
        case 5:
          openViewModal()
        break;
      default:
        break;
    }
  };

  const dropdownList = [
    { label: "View Info", key: 5, permission: []},
    { label: "View Profile", key: 1, permission: [USER_TYPE?.ACCOUNT_DIRECTOR, USER_TYPE?.ADMINSTRATOR,] },
    { label: "Reset Password", key: 2, permission: [USER_TYPE?.ACCOUNT_DIRECTOR, USER_TYPE?.ADMINSTRATOR,]},
    { label: "Resend Active Link", key: 3, permission: [USER_TYPE?.ACCOUNT_DIRECTOR, USER_TYPE?.ADMINSTRATOR,]},
    { label: "Delete User", key: 4,  permission: [USER_TYPE?.ACCOUNT_DIRECTOR, USER_TYPE?.ADMINSTRATOR,]},
  ];

  const columns = [
    {
      title: "Full Name",
      dataIndex: "profilePictureUrl",
      key: "profilePictureUrl",
      render: (text, record) => (
        <Avatar
          src={record?.profilePictureUrl}
          size={"38px"}
          name={`${record?.lastName} ${record?.firstName}`}
          info={`${record?.userType?.description}`}
        />
      ),
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      render: (text, record) => (<Boxed>
         {record?.department?.description} <br/>
        </Boxed>)
    },
    {
      title: "Contact",
      dataIndex: "email",
      key: "email",
      render: (text, record) => (
        <Boxed>
          {text} <br />({record?.phoneNumber?.countryCode}){" "}
          {record?.phoneNumber?.phone}
        </Boxed>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => text && formatDateTime(text),
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      align: "right",
      render: (text, record) => {
        let newList = dropdownList.filter(item => { 
          if( item?.permission?.length < 1) { 
            return true;
          }
          if(record?.userType?.description === USER_TYPE?.ACCOUNT_DIRECTOR && profile?.userType?.description !== USER_TYPE?.ACCOUNT_DIRECTOR) { 
            return false;
          }

          if(item.permission.includes(profile?.userType?.description) ){ 
            return true;
          } else { 
            return false;
          }
        })
        
        return (
          <DropDownMenu
            list={newList}
            handleAction={(value) => handleDropDown(value, record)}
          />
        );
      },
    },
  ];

  return (
    <>
      <Boxed pad="20px">
        <PageTitle>Users Management</PageTitle>
        <Boxed pad="10px 0">
          <Wrapper
            externalActionURL={fetchActionURL}
            render={({
              changePageSize,
              handlePagination,
              currentPage,
              pageSize,
              search,
            }) => {
              return (
                <>
                  <Grid
                    desktop="repeat(4, 1fr)"
                    tablet="repeat(4, 1fr)"
                    mobile="repeat(1, 1fr)"
                  >
                    <Boxed pad="5px 0">
                      <Input
                        type="search"
                        placeholder="Search by name, email & phone"
                        onChange={(value) => search(value, fetchActionURL)}
                      />
                    </Boxed>
                    <Boxed />
                    <Boxed />
                    { (accessList[USER_TYPE?.ACCOUNT_DIRECTOR] || accessList[USER_TYPE?.ADMINSTRATOR]) &&  <Boxed pad="5px 0" align="right">
                      <Button onClick={() => openCreateModal()}>
                        Add User
                      </Button>
                    </Boxed>}
                  </Grid>
                  {isLoading ? (
                    <Boxed display="flex" pad="20px">
                      <Loader margin="auto" />
                    </Boxed>
                  ) : (
                    <>
                      {" "}
                      {usersTotal > 0 ? (
                        <>
                          <TableComponent columns={columns} data={usersList} />
                          <Boxed pad="10px 0 ">
                            <PaginationComponent
                              total={usersTotal}
                              onChange={(page) =>
                                handlePagination(page, fetchActionURL)
                              }
                              current={currentPage}
                              pageCounts={pageOptions}
                              changePageSize={(pageSize) =>
                                changePageSize(pageSize, fetchActionURL)
                              }
                              pageSize={pageSize}
                              itemsDisplayed
                              showTotal={(total, range) => {
                                return `${range[0]} - ${range[1]} of ${usersTotal} items`;
                              }}
                            />
                          </Boxed>
                        </>
                      ) : (
                        <EmptyState />
                      )}
                    </>
                  )}
                </>
              );
            }}
          />
        </Boxed>
      </Boxed>
      {createUserModal && <CreateModal />}
      {deleteUserModal && <DeleteModal />}
      {viewUserModal && <ViewUser />}
      {resetModal && <ResetModal label={desc} />}
    </>
  );
};
